"use strict";

module.exports = require("./_iterate")("forEach");



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/object/for-each.js
// module id = 82
// module chunks = 0